import type { Plant } from '@/versions/v1/schema/plant';
import { PLANT } from '@/versions/v1/shared/bunker-hill-seed';

/** TopBar / project-header badge — e.g. "STARTUP MONTH 4". */
export function plantStartupBadgeLabel(plant: Plant = PLANT): string {
  return `${plant.phase.toUpperCase()} MONTH ${plant.phaseMonth}`;
}

/** GM kicker suffix — e.g. "startup month 4". */
export function plantStartupKickerSuffix(plant: Plant = PLANT): string {
  return `${plant.phase} month ${plant.phaseMonth}`;
}

export function gmRoleKicker(plant: Plant = PLANT): string {
  return `Strategic overview · ${plantStartupKickerSuffix(plant)}`;
}

/** Compact rail badge — "M4" — the sidebar header has ~60px for it; the full label rides as the title. */
export function plantStartupBadgeShort(plant: Plant = PLANT): string {
  return `M${plant.phaseMonth}`;
}
